export const ADMINS_PAGE = {
    'ADMINS.PAGE.TITLE': 'Administratori KPMG',
    'ADMIN.ADD.MODAL.TITLE': 'Administrator KPMG',
    'ADMIN.REACTIVATE_ACCESS.MODAL.TITLE': 'Ești sigur că vrei să reactivezi administratorul?',
    'ADMIN.REACTIVATE_ACCESS.MODAL.SUBTITLE1': 'Reactivarea unui administrator îi va permite acestuia să:',
    'ADMIN.REACTIVATE_ACCESS.MODAL.CONSEQUENCE1_1': 'administreze clienți și alți administratori (adăugare, eliminare, editare)',
    'ADMIN.DEACTIVATE_ACCESS.MODAL.TITLE': 'Ești sigur că vrei să dezactivezi administratorul?',
    'ADMIN.DEACTIVATE_ACCESS.MODAL.SUBTITLE1': 'Dezactivarea unui administrator presupune că până la reactivare, acesta:',
    'ADMIN.DEACTIVATE_ACCESS.MODAL.CONSEQUENCE1_1': 'nu poate administra clienți și alți administratori (adăugare, eliminare, editare)'
};
